import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import AnimationContainer from 'components/animation-container'
import AnimatedHeading from 'components/animated-heading'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }
      

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            // background-color: #111;
            // background-image: url(${this.props.background.childImageSharp.fluid.src});
            // background-image: radial-gradient(circle, rgba(13,31,64,1) 0%, rgba(167,167,167,1) 52%, rgba(13,31,64,1) 100%);
            // background-image: linear-gradient(to bottom left, #000000, #E7E9BB);
            background: rgb(13,31,64);
            background: linear-gradient( rgba(13,31,64,1) 0%, rgba(7,43,110,1) 52%, rgba(13,31,64,1) 100%);
            background: -webkit-linear-gradient( rgb(13,31,64) 0%, rgba(7,43,110,1) 52%, rgba(13,31,64,1) 100%);
            background-size: cover;
            .heading {
                width: 100%;
            }
          }
        `

        const ServiceContainer = styled.div`
            // background-color: rgba(0,0,0,.9);
            padding: 100px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                //background-color: #04275c;
                //background: rgba(255,255,255,0);
            background: radial-gradient(circle, rgba(198,198,198,0) 0%, rgb(19,53,108) 100%);
                box-shadow: 0 28px 60px rgb(4, 229, 229, .1);
                transform: translateY(-10px);
                border: 1px solid rgba(255,255,255,0.3);
            }
        `
         const ServiceHeading = styled.h4`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #FFA500;
            margin-bottom: 10px;
            margin: auto;
         `
        const ServiceIcon = styled.div`
            margin-bottom: 20px;
            img {
                max-height: 70px;
            }
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #c5c5c5;
            font-weight: 300;
            font-size: 14px;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color:#FFA500;
                position: relative;
                bottom: 2.5px;
            }
        `

        const AgileInfo = styled.h3`
        font-size: 40px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            text-align: center;
            // margin-top: 20px;
            
             @media (max-width: 500px) {
                font-size: 25px;
                line-height: 25px;
            }
        `

        const FullWidthSeparator = styled.div`
        height: 5px;
            // width: 100vw;
            background-color: #FFA500;
            // margin-bottom: 10px;
            // margin: auto;
            margin: 30px;
        `

        const MarginDiv = styled.div`
        margin-top: 100px;
        `

        const Color = styled.span`
            color: #FFA500;
        `

        return(
            <Section id="how we do it">
                <ServiceContainer>
                    <Container>
                        <AnimatedHeading text="How we do it" />
                        <Row>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInLeft" delay={200}>
                                        <ServiceElement>
                                            <ServiceIcon>
                                                    <img src="/techIcons/react.svg" alt="React.js" />
                                            </ServiceIcon>
                                            <ServiceHeading>
                                                React.js
                                            </ServiceHeading>
                                            <ServiceSeparator/>
                                            <ServiceList>
                                                <ServiceListElement>
                                                    JavaScript library for building user interfaces
                                                </ServiceListElement>
                                                {/*<ServiceListElement>*/}
                                                {/*    In vitae ultricies lacus vitae*/}
                                                {/*</ServiceListElement>*/}
                                                {/*<ServiceListElement>*/}
                                                {/*    Pellentesque blandit libero*/}
                                                {/*</ServiceListElement>*/}
                                            </ServiceList>
                                        </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInDown"  delay={400}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                                <img src="/techIcons/gatsby.svg" alt="Gatsby" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Gatsby
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                React-based framework for creating extremaly fast web applications
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={600}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                                <img src="/techIcons/laravel.svg" alt="Laravel" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Laravel
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                PHP web application framework
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInLeft" delay={800}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                                <img src="/techIcons/java.svg" alt="Java" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                           Java
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                 Extremely secure object oriented programming language
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInUp" delay={1000}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                                <img src="/techIcons/mariadb.svg" alt="MariaDB" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            MariaDB
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                Database solution for modern applications
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                    <AnimationContainer animation="fadeInRight" delay={1200}>
                                        <ServiceElement>
                                            <ServiceIcon>
                                                    <img src="/techIcons/firebase.svg" alt="Firebase" />
                                            </ServiceIcon>
                                            <ServiceHeading>
                                                Firebase
                                            </ServiceHeading>
                                            <ServiceSeparator/>
                                            <ServiceList>
                                                <ServiceListElement>
                                                    Google platform for creating mobile and web applications
                                                </ServiceListElement>
                                                {/*<ServiceListElement>*/}
                                                {/*    In vitae ultricies lacus vitae*/}
                                                {/*</ServiceListElement>*/}
                                                {/*<ServiceListElement>*/}
                                                {/*    Pellentesque blandit libero*/}
                                                {/*</ServiceListElement>*/}
                                            </ServiceList>
                                        </ServiceElement>
                                    </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/vue.svg" alt="Vue" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Vue.js
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                Progressive framework for building user interfaces
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/angular.svg" alt="Angular" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Angular
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                Platform for building mobile and desktop web applications
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/postgresql.svg" alt="PostgreSQL" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            PostgreSQL
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                Relational database management system
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/nodejs.svg" alt="Node.js" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Node.js
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                JavaScript runtime environment
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/bitcoin.svg" alt="Bitcoin" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Bitcoin
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                We have been working with cryptocurrencies in diverse projects for many years
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                            <Col md={4}>
                                <AnimationContainer animation="fadeInRight" delay={1200}>
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <img src="/techIcons/electron.svg" alt="Electron" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Electron
                                        </ServiceHeading>
                                        <ServiceSeparator/>
                                        <ServiceList>
                                            <ServiceListElement>
                                                Software framework for desktop GUI applications development
                                            </ServiceListElement>
                                            {/*<ServiceListElement>*/}
                                            {/*    In vitae ultricies lacus vitae*/}
                                            {/*</ServiceListElement>*/}
                                            {/*<ServiceListElement>*/}
                                            {/*    Pellentesque blandit libero*/}
                                            {/*</ServiceListElement>*/}
                                        </ServiceList>
                                    </ServiceElement>
                                </AnimationContainer>
                            </Col>
                        </Row>
                        <MarginDiv>
                        <AgileInfo>
                            All the tasks are delivered with the schedule. <Color>Always on time.</Color>
                        </AgileInfo>
                        <FullWidthSeparator/>
                        <AgileInfo>
                            We work in sprints with daily scrums following <Color>agile</Color> mindset.
                        </AgileInfo>
                        </MarginDiv>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

export default props => (
    <StaticQuery
      query={graphql`
      query {
        background: file(relativePath: {eq: "bg2.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 4000, quality: 100) {
              src
            }
          }
        }
        web: file(relativePath: {eq: "icons/web.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        mobile: file(relativePath: {eq: "icons/mobile.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        seo: file(relativePath: {eq: "icons/seo2.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        email: file(relativePath: {eq: "icons/email.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        ui: file(relativePath: {eq: "icons/sketch.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        network: file(relativePath: {eq: "icons/network.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
      }      
      `}
      render={({ 
        background,
        web,
        mobile,
        seo,
        email,
        ui,
        network}) => <ServicesOne  
        background={background}
        web={web}
        mobile={mobile}
        seo={seo}
        email={email}
        ui={ui}
        network={network}
        {...props} />}
    />
  )